import React, { useContext, useEffect, useState } from "react";
import ExpeditionsMain from "../images/ExpeditionsMain.jpg";
import ExperiencesMain from "../images/ExperiencesMain.jpg";
import bottomarrow from "../images/down_arrow.png";
import Wrapper from "../components/wrapper/Wrapper";
import BoxItem from "../components/BoxItem";
import boxItemIgm1 from "../images/box_item_1.png";
import levelImg1 from "../images/cell_signal_1.png";
import FilterAccord from "../components/FilterAccord";
import { useParams } from "react-router-dom";
import { ThemeContext } from "../Context/Theme/Context";
import { getBlog } from "../servies/services";
import CMSBg from "../images/cmsBg.jpg";
import CMSBgMobile from "../images/cmsBgMobile.jpg";

const filterItems = [
    {
        id: 1,
        filterTitle: "DiffDifficulty Level",
        defaultShow: true,
    },
    {
        id: 2,
        filterTitle: "Location",
        defaultShow: false,
    },
    {
        id: 3,
        filterTitle: "Price",
        defaultShow: false,
    }
];

const BlogList = () => {
    const { title } = useParams()
    const { mainCategory } = useContext(ThemeContext)
    const [data, setData] = useState(filterItems);

    const [mainData, setMainData] = useState([]);

    useEffect(() => {
        const getData = async () => {
            const blogData = await getBlog('blog');
            setMainData(blogData?.data.data);
        }
        getData();
    }, [])

    return (
        <>
            <Wrapper
                showTopFooter={false}
                desktopImage={CMSBg}
                mobileImage={CMSBgMobile}
                firstTitle="Journey Beyond Limits"
                bannerHeading={"Blog"}
                bansubheading="Explore, Dream, Discover!"
            >
                <div className="container level_box_outer mt-3">
                    <div className="row">
                        {mainData?.map((dataItem) => {
                            const { publish_date, title, description, slug } = dataItem;
                            return (
                                <BoxItem
                                    imgSrc={boxItemIgm1}
                                    altTitle="box image 1"
                                    date={publish_date}
                                    contentTitle={title}
                                    boxPara={description}
                                    link={`/blog/${slug}`}
                                    customClass="col-md-4"
                                />
                            )
                        })}
                    </div>
                </div>
            </Wrapper>
            
        </>
    )
};

export default BlogList;
